import { render } from "./BigScreensFaq.vue?vue&type=template&id=61fb0227"
import script from "./BigScreensFaq.vue?vue&type=script&lang=js"
export * from "./BigScreensFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__